import { Router } from '@angular/router';
import { Auth } from './../../autentication/Auth';
import { EventTypes } from './../EventTypes';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ThemeService } from '../theme-service/theme.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {
	primaryColor: any;

	open = true;
	nomeParceiro = '';
	isAttendant: boolean = false;

	constructor(private route: Router, private themeService: ThemeService) { }

	openMenu(open) {
		this.open = open;

		if (this.open) {
			AppEventDispatcher.dispatch(EventTypes.MENU.TOGGLE, {open: true});
			this.open = false;
		} else {
			AppEventDispatcher.dispatch(EventTypes.MENU.TOGGLE, {open: false});
			this.open = true;
		}
	}

	ngOnInit() {

		let themeConfigs = this.themeService.getThemeConfigs();
		this.nomeParceiro = themeConfigs.NomeParceiro;
		this.isAttendant = this.themeService.isAttendant();
		this.themeService.setCssVariables(themeConfigs);
		
		if (this.themeService.themeConfigs) {
			this.primaryColor = this.themeService.CorPrimaria ? this.themeService.CorPrimaria : '';
		}
	}

	logout() {
		Auth.getInstance().logout();
		this.route.navigate(['login']);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/header/header.component.ts